import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { ConfigService } from '../../../core/services/config.service';
import { RequestService } from '../../../core/services/request.service';
import { AmberApi } from '../../../core/models/api-helpers';

@Injectable()
export class AccountConfigurationService {
    seed: { userSource: (request: any, response: any) => void };
    minimumCharacterSearch = 3;
    constructor(
        private requestService: RequestService,
        private configService: ConfigService
    ) { }

    getAccountConfigurationListAPIUrl() {
        return this.configService.get('server').url + this.configService.get('endpoints').agora.domainConfigurations.list.api;
    }

    getAccountConfigAddUrl() {
        return this.configService.get('server').url + this.configService.get('endpoints').agora.domainConfigurations.add.api;
    }

    getAccountConfigEditUrl() {
        return this.configService.get('server').url + this.configService.get('endpoints').agora.domainConfigurations.edit.api;
    }

    saveAccountConfig(details: any) {
        return this.requestService.post(this.getAccountConfigAddUrl(), details).map(_ => _.data);
    }

    editAccountConfig(details: any) {
        return this.requestService.post(this.getAccountConfigEditUrl(), details).map(_ => _.data);
    }

    deleteAccountConfig(details: any) {
        return this.requestService.post(
            this.configService.get('server').url + this.configService.get('endpoints').agora.domainConfigurations.delete.api, details).map(_ => _.data);
    }

    getDetails(id) {
        return this.requestService.get(
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.domainConfigurations.details.api + '/' + id);
    }

    getDomains() {
        return this.requestService.get(
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.domainConfigurations.domain.api).map(_ => _.data);
    }

    getGroups() {
        return this.requestService.get(
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.domainConfigurations.getGroupTypesDict.api).map(_ => _.data);
    }
    getMinimumCharacterFordomainCall() {
        return this.minimumCharacterSearch;
    }
    keywordsSource() {
        let requestSubject = new Subject<any>();
        requestSubject.debounceTime(500).filter(val => val.request && val.request.trim().length >= this.getMinimumCharacterFordomainCall())
            .distinctUntilChanged((p: any, q: any) => p.request === q.request)
            .switchMap(val => {
                const url = this.configService.get('server').url +
                    this.configService.get('endpoints').agora.domainConfigurations.domain.api + '?verbose=true&@name=' + val.request;
                return Observable.zip(Observable.of(val), this.requestService.get(url).extract(AmberApi.Data));
            })
            .map(_ => {
                let result = [];
                for (let i = 0; i < _[1].length; i++) {
                    result.push(_[1][i].value);
                }

                return { req: _[0], data: result };
            })
            .subscribe(
                res => res.req.response(res.data)
            );

        return {
            userSource: (request: any, response: any) => {
                requestSubject.next({ request: request.term, response: response });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-configurations/account-configuration.service.ts